import React from 'react'
import useMyProductFormContext from '@src/hooks/product/form/useProductFormContext'
import Input from '@src/components/inputs/Input'
import SectionBlock from './SectionBlock'
import { css } from '@emotion/react'

const NormalPriceForm = () => {
	const { getNormalPriceFormProps } = useMyProductFormContext()
	const { getFieldProps, stockExist, isOptionExist } = getNormalPriceFormProps()

	if (isOptionExist) return null
	return (
		<SectionBlock title="상품가격 설정">
			<Input
				label="판매가"
				min="0"
				{...getFieldProps('price')}
				type="number"
				wrapperStyle={inputWrapperStyle}
				labelStyle={css`
					white-space: nowrap;
				`}
				css={inputStyle}
			/>
			<Input
				label="챌린지 성공 시, 할인가"
				{...getFieldProps('challengePrice')}
				type="number"
				min="0"
				wrapperStyle={inputWrapperStyle}
				css={inputStyle}
			/>

			<Input
				label="재고 수량 설정"
				{...getFieldProps('stockExist')}
				type="checkbox"
				id="is_stock_check"
				labelStyle={css`
					width: auto;
					margin-left: 1rem;
				`}
				wrapperStyle={css`
					flex-direction: row-reverse;
					align-items: center;
					justify-content: flex-end;
				`}
			/>
			<Input
				label="재고"
				{...getFieldProps('stock')}
				disabled={!stockExist}
				type="number"
				min="0"
				wrapperStyle={inputWrapperStyle}
				css={inputStyle}
			/>
		</SectionBlock>
	)
}

const inputWrapperStyle = css`
	margin-bottom: 1rem;
	flex-flow: column;
`
const inputStyle = css`
	box-sizing: border-box;
	width: 20rem;
`

export default NormalPriceForm
